import api from "./api";

export const $sq_getCommodityList = (params,loding) => api.postNoTips("/hengxin/erp/api/client/biz/goods/page/v2", params);

export const $sp_categoryList = params => api.postNoTips("/hengxin/erp/api/client/biz/goodsCategory/categoryList", params);

//商品详情
export const $sg_getCommodityDetail = params => api.postNoTips("/hengxin/erp/api/client/biz/goods/info/v1_2", params);

//添加收藏
export const $sg_addOften = params => api.get("/hengxin/erp/api/client/biz/goods/addOften", params);
//删除收藏
export const $sg_deleteOften = params => api.get("/hengxin/erp/api/client/biz/goods/deleteOften", params);
//清空收藏
export const $sg_clearOften = params => api.get("/hengxin/erp/api/client/biz/goods/clearOften", params);

//领取优惠券
export const $sp_receiveCoupon = params => api.post("/hengxin/erp/api/client/biz/mine/coupon/receiveCoupon", params);
//领劵中心
export const $sg_getCouponCenter = params => api.getNoTips("/hengxin/erp/api/client/biz/mine/coupon/getCouponCenter", params);

//购物车-列表
export const $sg_getShopCar = params => api.postNoTips("/hengxin/erp/api/client/biz/order/getAllItem/v1_2_1", params);
//购物车数量
export const $sg_getShopCarNum = params => api.getNoTips("/hengxin/erp/api/client/biz/order/shopcar/goods/count", params);
//购物车-添加
export const $sp_addShopCar = params => api.postNoTips("/hengxin/erp/api/client/biz/order/choose", params);
//购物车-批量删除
export const $sp_delShopCar = params => api.postNoTips("/hengxin/erp/api/client/biz/order/delete/shopcar", params);


//对账单
export const $sg_getStatementList = params => api.getNoTips("/hengxin/erp/api/client/biz/my/pc-statement/list", params);